import React from 'react';
import Styles from '../assets/css/layouts/navbar.module.scss';
import { sidebarOff, sidebarOn } from "../features/navbar/toggleSlice";
import { useDispatch, useSelector } from 'react-redux';
import { FaBars } from "react-icons/fa";

const Navbar = () => {

    const toggleValue = useSelector(state => state.toggle.toggle);
    const dispatch = useDispatch();

    return (
        <div className={`${Styles.navbar} ${toggleValue ? Styles.active : ""}`}>
            <div className={`${Styles.nav} ${Styles.container}`}>
                <div className={`${Styles.toggle}`}>
                    <FaBars onClick={() => toggleValue ? dispatch(sidebarOn()) : dispatch(sidebarOff())} />
                </div>
            </div>
        </div>
    )
}

export default Navbar
